export enum ReadingProgramType {
  singleWords = 0,
  couplets = 1,
  sentences = 2,
  homemadeBooks = 4
}
